// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".date-time-field_915f label {\n  left: 0 !important;\n}\n.date-time-field_915f.labeled_5f2b {\n  padding-top: 1.875rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/DateTimeField.scss","DateTimeField.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;ACAR;ADGI;EACI,qBAAA;ACDR","file":"DateTimeField.scss","sourcesContent":[".date-time-field {\n    label {\n        left: 0 !important;\n    }\n\n    &.labeled {\n        padding-top: 1.875rem;\n    }\n}\n",".date-time-field label {\n  left: 0 !important;\n}\n.date-time-field.labeled {\n  padding-top: 1.875rem;\n}"]}]);
// Exports
exports.locals = {
	"date-time-field": "date-time-field_915f",
	"labeled": "labeled_5f2b"
};
module.exports = exports;
